export default "__VITE_ASSET__CLS6h$3q__"